import { gql } from '@apollo/client';

export const GET_MEETING = gql`
  query Meeting($meetingId: String!) {
    meeting(meetingId: $meetingId) {
      _id
      meetingId
      created
      endAt
      icebreakers
      isRecurringEvent
      location
      meetingName
      startAt
      summary
      attendees {
        confident
        career_summary
        education_summary
        fun_fact
        linkedin_profile
        location
        position
        profile_pic_url
        user_email
        user_full_name
        lastInteraction {
          date
          interactionType
        }
        company_info {
          annual_revenue
          description
          domain
          employees
          founded_year
          industries
          location
          name
          product_services
          total_funding
          website
        }
      }
    }
  }
`;

export const GET_INTERNAL_MEETING = gql`
  query Meeting($meetingId: String!) {
    internalMeeting(meetingId: $meetingId) {
      id
      eventTitle
      start
      end
      location
      isRecurringEvent
      attendees {
        email
        displayName
      }
    }
  }
`;

export const ALL_MEETINGS = gql`
  query AllMeetings($date: Float, $endDate: Float) {
    allMeetings(date: $date, endDate: $endDate) {
      internals {
        id
        eventTitle
        start
        end
        location
        isRecurringEvent
        attendees {
          email
          displayName
        }
      }
      eventClassification {
        id
        eventType
        meetingLink
        meetingLocation
      }
      externals {
        _id
        meetingId
        created
        endAt
        icebreakers
        isRecurringEvent
        location
        meetingName
        startAt
        summary
        attendees {
          confident
          career_summary
          education_summary
          fun_fact
          linkedin_profile
          location
          position
          profile_pic_url
          user_email
          user_full_name
          lastInteraction {
            date
            interactionType
          }
          company_info {
            annual_revenue
            description
            domain
            employees
            founded_year
            industries
            location
            name
            product_services
            total_funding
            website
          }
        }
      }
    }
  }
`;

export const SCHEDULED_BOTS = gql`
  query ScheduledBots {
    scheduledBots {
      id
      meetingId
      botId
      status
    }
  }
`;
